/* eslint-disable array-element-newline */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-bind */
import {Elements, RecurlyProvider} from "@recurly/react-recurly";
import BillingInfoForm from "./BillingInfoForm";
import NonMemberCartHeader from "./NonMemberCartHeader";
import PropTypes from "prop-types";
import React from "react";

const BillingInfoContainer = ({
  billingInfo,
  recurlyPublicKey,
  setBillingInfo,
  setDisplayErrors,
  setError,
  setIsEditingBilling
}) => {
  const handleGoBack = () => {
    setIsEditingBilling(false);
  };

  const renderCreditCardForm = () => (
    <RecurlyProvider
      publicKey={recurlyPublicKey}
      required={["cvv"]}
    >
      <Elements>
        <BillingInfoForm
          billingInfo={billingInfo}
          setBillingInfo={setBillingInfo}
          setDisplayErrors={setDisplayErrors}
          setError={setError}
          setIsEditingBilling={setIsEditingBilling}
        />
      </Elements>
    </RecurlyProvider>
  );

  return (
    <div className="billing-info-edit ">
      <NonMemberCartHeader
        classes="justify-start items-start gap-2.5 -mx-5 text-lg"
        handleBackButton={handleGoBack}
        showBackButton
        title="add billing"
      />
      {renderCreditCardForm()}
    </div>
  );
};


BillingInfoContainer.propTypes = {
  "billingInfo": PropTypes.string.isRequired,
  "recurlyPublicKey": PropTypes.string.isRequired,
  "setBillingInfo": PropTypes.func.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired,
  "setIsEditingBilling": PropTypes.func.isRequired
};

export default BillingInfoContainer;
